import React from 'react';
import {Link} from '@/i18n/navigation';
import {Typography} from '@mui/material';
import RightArrowIcon from '@/components/ui/icons/RightArrow';
import ContentfulImage from '@/components/ui/image/ContentfulImage';
import {
  StyledTopicCardContainer, StyledTopicCardContentContainer,
  StyledTopicCardCtaContainer,
  StyledTopicCardImageContainer,
  StyledTopicCardRoot
} from '@/components/sections/topic-section/TopicCard.styles';
import {formatDateYYYYMMDD} from '@/lib/date-format';

type TopicCardProps = {
    heading?: string | null;
    imageUrl: string;
    href: string;
    topic: string;
    date?: string | Date | null;
    imageAlt?: string | null;
    focalX?: number | null;
    focalY?: number | null;
};

const TopicCard = React.memo(function TopicCard({ heading, imageUrl, href, topic, date, imageAlt, focalY, focalX }: TopicCardProps) {
  const formattedDate = date ? formatDateYYYYMMDD(date) : null;

  const inner = (
    <StyledTopicCardRoot>
      <StyledTopicCardImageContainer>
        <ContentfulImage src={imageUrl} alt={imageAlt ?? ''}
          sizes='(max-width: 600px) 100vw, 50vw'
          style={{ objectFit: 'cover' }}
          focalX={focalX}
          focalY={focalY}
          fill
        />

        <StyledTopicCardContainer>
          {(heading || formattedDate) && (
            <StyledTopicCardContentContainer>
              {formattedDate && (
                <Typography className='heading' variant='subtitle2' sx={{ marginBottom: 0.5 }}>
                  {formattedDate}
                </Typography>
              )}
              {heading && (
                <Typography className='heading heading--title' variant='h4'>
                  {heading}
                </Typography>
              )}
            </StyledTopicCardContentContainer>
          )}
        </StyledTopicCardContainer>
      </StyledTopicCardImageContainer>

      <StyledTopicCardCtaContainer>
        <Typography className='heading' variant='body1'>
          {topic}
        </Typography>
        <RightArrowIcon size={22} color='white' />
      </StyledTopicCardCtaContainer>
    </StyledTopicCardRoot>
  );

  return (
    <Link href={href}>
      {inner}
    </Link>
  );
});

export default TopicCard;
